// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-page {
  background: #fff;
  color: #2e2e2e;
  font-family: "Gilroy", 'Poppins', sans-serif;
  overflow-x: hidden;
}

.about-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 32px;
}

/* Scroll reveal */
.reveal {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal.is-visible {
  opacity: 1;
  transform: none;
}

.about-eyebrow {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.65);
  margin-bottom: 20px;
}
.about-eyebrow.dark {
  color: #909090;
}

.about-h2 {
  font-size: clamp(28px, 4vw, 44px);
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0;
  color: #2e2e2e;
}
.about-h2.light {
  color: #fff;
}

.about-center {
  text-align: center;
}

/* Hero */
.about-hero {
  position: relative;
  background: #2e2e2e;
  color: #fff;
  text-align: center;
  padding: 120px 0 110px;
  overflow: hidden;
}
.about-hero-glow {
  position: absolute;
  inset: -20% -10% auto -10%;
  height: 120%;
  background:
    radial-gradient(circle at 20% 30%, rgba(255, 214, 170, 0.22), transparent 45%),
    radial-gradient(circle at 80% 60%, rgba(170, 200, 255, 0.18), transparent 50%);
  animation: aboutGlow 14s ease-in-out infinite alternate;
}
@keyframes aboutGlow {
  from { transform: translate3d(-2%, 0, 0) scale(1); }
  to { transform: translate3d(2%, 3%, 0) scale(1.08); }
}
.about-hero-inner {
  position: relative;
}
.about-hero-title {
  font-size: clamp(34px, 6vw, 72px);
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.03em;
  max-width: 900px;
  margin: 0 auto 28px;
}
.about-hero-lead {
  font-size: clamp(16px, 2vw, 20px);
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.8);
  max-width: 720px;
  margin: 0 auto;
}
.about-scroll-hint {
  width: 1px;
  height: 64px;
  margin: 56px auto 0;
  background: linear-gradient(#fff, transparent);
  animation: aboutHint 2.2s ease-in-out infinite;
}
@keyframes aboutHint {
  0%, 100% { opacity: 0.25; }
  50% { opacity: 1; }
}

/* Sections */
.about-section {
  padding: 110px 0;
}
.about-two-col {
  display: grid;
  grid-template-columns: 5fr 7fr;
  gap: 72px;
  align-items: start;
}
.about-two-col.reverse {
  grid-template-columns: 5fr 7fr;
}
.about-col-head {
  position: sticky;
  top: 40px;
}
.about-col-body p {
  font-size: 17px;
  line-height: 1.85;
  color: #4a4a4a;
  margin: 0 0 22px;
}
.about-col-body .about-lead-p {
  font-size: 21px;
  line-height: 1.7;
  color: #2e2e2e;
  font-weight: 500;
}
.about-col-body .about-strong-p,
.about-col-body .about-ambition {
  color: #2e2e2e;
  font-weight: 700;
  font-size: 19px;
  padding-left: 22px;
  border-left: 3px solid #2e2e2e;
}

/* Timeline */
.about-timeline {
  list-style: none;
  margin: 90px 0 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  position: relative;
}
.about-timeline::before {
  content: '';
  position: absolute;
  top: 46px;
  left: 0;
  right: 0;
  height: 2px;
  background: #e2e2e2;
}
.about-tl-item {
  position: relative;
  padding-top: 0;
}
.about-tl-year {
  display: block;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 18px;
  color: #2e2e2e;
}
.about-tl-dot {
  display: block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #2e2e2e;
  border: 3px solid #fff;
  box-shadow: 0 0 0 2px #2e2e2e;
  margin-bottom: 22px;
  position: relative;
}
.about-tl-item h3 {
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 8px;
}
.about-tl-item p {
  font-size: 15px;
  line-height: 1.6;
  color: #656565;
  margin: 0;
}

/* Mission */
.about-mission {
  background: #2e2e2e;
  color: #fff;
}
.about-mission-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
  margin-top: 64px;
}
.about-mission-grid p {
  font-size: 16px;
  line-height: 1.85;
  color: rgba(255, 255, 255, 0.78);
  margin: 0;
  padding-top: 24px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.about-quote {
  margin: 90px auto 70px;
  max-width: 860px;
  text-align: center;
  font-size: clamp(24px, 3.4vw, 40px);
  line-height: 1.3;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.about-quote::before {
  content: '“';
  display: block;
  font-size: 90px;
  line-height: 0.6;
  color: rgba(255, 255, 255, 0.25);
  margin-bottom: 12px;
}
.about-values {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}
.about-values li {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 22px 24px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  font-size: 17px;
  font-weight: 600;
  transition: background 0.25s ease, transform 0.8s ease, opacity 0.8s ease;
}
.about-values li:hover {
  background: rgba(255, 255, 255, 0.07);
}
.about-value-num {
  font-size: 13px;
  letter-spacing: 0.1em;
  color: rgba(255, 255, 255, 0.5);
}

/* Vision */
.about-vision {
  background: #f6f4f1;
}
.about-globe {
  position: relative;
  width: 150px;
  height: 150px;
  margin-top: 44px;
}
.about-globe span {
  position: absolute;
  inset: 0;
  border: 2px solid #2e2e2e;
  border-radius: 50%;
}
.about-globe span:nth-child(2) {
  transform: scaleX(0.45);
}
.about-globe span:nth-child(3) {
  transform: scaleY(0.45);
}

/* Closing */
.about-closing {
  padding: 120px 0;
  text-align: center;
}
.about-closing-title {
  font-size: clamp(28px, 4.4vw, 52px);
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  max-width: 800px;
  margin: 0 auto 40px;
}
.about-cta {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  background: #2e2e2e;
  color: #fff;
  text-decoration: none;
  font-weight: 600;
  font-size: 17px;
  padding: 18px 36px;
  border-radius: 999px;
  transition: transform 0.25s ease, box-shadow 0.25s ease, gap 0.25s ease, opacity 0.8s ease;
}
.about-cta:hover {
  gap: 18px;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);
}

/* Tablet / mobile */
@media (max-width: 900px) {
  .about-section { padding: 72px 0; }
  .about-two-col,
  .about-two-col.reverse { grid-template-columns: 1fr; gap: 32px; }
  .about-col-head { position: static; }
  .about-globe { width: 100px; height: 100px; margin-top: 28px; }
  .about-timeline { grid-template-columns: 1fr 1fr; row-gap: 48px; margin-top: 60px; }
  .about-timeline::before { display: none; }
  .about-mission-grid { grid-template-columns: 1fr; gap: 28px; margin-top: 40px; }
  .about-values { grid-template-columns: 1fr; }
  .about-quote { margin: 60px auto 48px; }
}

@media (max-width: 560px) {
  .about-container { padding: 0 20px; }
  .about-hero { padding: 80px 0 72px; }
  .about-scroll-hint { margin-top: 36px; height: 44px; }
  .about-timeline { grid-template-columns: 1fr; }
  .about-col-body .about-lead-p { font-size: 18px; }
  .about-col-body p { font-size: 16px; }
  .about-closing { padding: 80px 0; }
}

@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; transition: none; }
  .about-hero-glow, .about-scroll-hint { animation: none; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/About.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ;;kFAEgF;EAChF,uDAAuD;AACzD;AACA;EACE,OAAO,0CAA0C,EAAE;EACnD,KAAK,6CAA6C,EAAE;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,8CAA8C;EAC9C,8CAA8C;AAChD;AACA;EACE,WAAW,aAAa,EAAE;EAC1B,MAAM,UAAU,EAAE;AACpB;;AAEA,aAAa;AACb;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,SAAS;EACT,iBAAiB;EACjB,8CAA8C;AAChD;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yEAAyE;AAC3E;AACA;EACE,qCAAqC;AACvC;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,0FAA0F;AAC5F;AACA;EACE,SAAS;EACT,0CAA0C;AAC5C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB,eAAe,EAAE;EAClC;2BACyB,0BAA0B,EAAE,SAAS,EAAE;EAChE,kBAAkB,gBAAgB,EAAE;EACpC,eAAe,YAAY,EAAE,aAAa,EAAE,gBAAgB,EAAE;EAC9D,kBAAkB,8BAA8B,EAAE,aAAa,EAAE,gBAAgB,EAAE;EACnF,0BAA0B,aAAa,EAAE;EACzC,sBAAsB,0BAA0B,EAAE,SAAS,EAAE,gBAAgB,EAAE;EAC/E,gBAAgB,0BAA0B,EAAE;EAC5C,eAAe,sBAAsB,EAAE;AACzC;;AAEA;EACE,mBAAmB,eAAe,EAAE;EACpC,cAAc,oBAAoB,EAAE;EACpC,qBAAqB,gBAAgB,EAAE,YAAY,EAAE;EACrD,kBAAkB,0BAA0B,EAAE;EAC9C,gCAAgC,eAAe,EAAE;EACjD,oBAAoB,eAAe,EAAE;EACrC,iBAAiB,eAAe,EAAE;AACpC;;AAEA;EACE,UAAU,UAAU,EAAE,eAAe,EAAE,gBAAgB,EAAE;EACzD,uCAAuC,eAAe,EAAE;AAC1D","sourcesContent":[".about-page {\n  background: #fff;\n  color: #2e2e2e;\n  font-family: \"Gilroy\", 'Poppins', sans-serif;\n  overflow-x: hidden;\n}\n\n.about-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 32px;\n}\n\n/* Scroll reveal */\n.reveal {\n  opacity: 0;\n  transform: translateY(28px);\n  transition: opacity 0.8s ease, transform 0.8s ease;\n}\n.reveal.is-visible {\n  opacity: 1;\n  transform: none;\n}\n\n.about-eyebrow {\n  display: inline-block;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.65);\n  margin-bottom: 20px;\n}\n.about-eyebrow.dark {\n  color: #909090;\n}\n\n.about-h2 {\n  font-size: clamp(28px, 4vw, 44px);\n  line-height: 1.15;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  margin: 0;\n  color: #2e2e2e;\n}\n.about-h2.light {\n  color: #fff;\n}\n\n.about-center {\n  text-align: center;\n}\n\n/* Hero */\n.about-hero {\n  position: relative;\n  background: #2e2e2e;\n  color: #fff;\n  text-align: center;\n  padding: 120px 0 110px;\n  overflow: hidden;\n}\n.about-hero-glow {\n  position: absolute;\n  inset: -20% -10% auto -10%;\n  height: 120%;\n  background:\n    radial-gradient(circle at 20% 30%, rgba(255, 214, 170, 0.22), transparent 45%),\n    radial-gradient(circle at 80% 60%, rgba(170, 200, 255, 0.18), transparent 50%);\n  animation: aboutGlow 14s ease-in-out infinite alternate;\n}\n@keyframes aboutGlow {\n  from { transform: translate3d(-2%, 0, 0) scale(1); }\n  to { transform: translate3d(2%, 3%, 0) scale(1.08); }\n}\n.about-hero-inner {\n  position: relative;\n}\n.about-hero-title {\n  font-size: clamp(34px, 6vw, 72px);\n  line-height: 1.08;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  max-width: 900px;\n  margin: 0 auto 28px;\n}\n.about-hero-lead {\n  font-size: clamp(16px, 2vw, 20px);\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.8);\n  max-width: 720px;\n  margin: 0 auto;\n}\n.about-scroll-hint {\n  width: 1px;\n  height: 64px;\n  margin: 56px auto 0;\n  background: linear-gradient(#fff, transparent);\n  animation: aboutHint 2.2s ease-in-out infinite;\n}\n@keyframes aboutHint {\n  0%, 100% { opacity: 0.25; }\n  50% { opacity: 1; }\n}\n\n/* Sections */\n.about-section {\n  padding: 110px 0;\n}\n.about-two-col {\n  display: grid;\n  grid-template-columns: 5fr 7fr;\n  gap: 72px;\n  align-items: start;\n}\n.about-two-col.reverse {\n  grid-template-columns: 5fr 7fr;\n}\n.about-col-head {\n  position: sticky;\n  top: 40px;\n}\n.about-col-body p {\n  font-size: 17px;\n  line-height: 1.85;\n  color: #4a4a4a;\n  margin: 0 0 22px;\n}\n.about-col-body .about-lead-p {\n  font-size: 21px;\n  line-height: 1.7;\n  color: #2e2e2e;\n  font-weight: 500;\n}\n.about-col-body .about-strong-p,\n.about-col-body .about-ambition {\n  color: #2e2e2e;\n  font-weight: 700;\n  font-size: 19px;\n  padding-left: 22px;\n  border-left: 3px solid #2e2e2e;\n}\n\n/* Timeline */\n.about-timeline {\n  list-style: none;\n  margin: 90px 0 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 24px;\n  position: relative;\n}\n.about-timeline::before {\n  content: '';\n  position: absolute;\n  top: 46px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #e2e2e2;\n}\n.about-tl-item {\n  position: relative;\n  padding-top: 0;\n}\n.about-tl-year {\n  display: block;\n  font-size: 22px;\n  font-weight: 800;\n  margin-bottom: 18px;\n  color: #2e2e2e;\n}\n.about-tl-dot {\n  display: block;\n  width: 14px;\n  height: 14px;\n  border-radius: 50%;\n  background: #2e2e2e;\n  border: 3px solid #fff;\n  box-shadow: 0 0 0 2px #2e2e2e;\n  margin-bottom: 22px;\n  position: relative;\n}\n.about-tl-item h3 {\n  font-size: 18px;\n  font-weight: 700;\n  margin: 0 0 8px;\n}\n.about-tl-item p {\n  font-size: 15px;\n  line-height: 1.6;\n  color: #656565;\n  margin: 0;\n}\n\n/* Mission */\n.about-mission {\n  background: #2e2e2e;\n  color: #fff;\n}\n.about-mission-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 40px;\n  margin-top: 64px;\n}\n.about-mission-grid p {\n  font-size: 16px;\n  line-height: 1.85;\n  color: rgba(255, 255, 255, 0.78);\n  margin: 0;\n  padding-top: 24px;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n}\n.about-quote {\n  margin: 90px auto 70px;\n  max-width: 860px;\n  text-align: center;\n  font-size: clamp(24px, 3.4vw, 40px);\n  line-height: 1.3;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n.about-quote::before {\n  content: '“';\n  display: block;\n  font-size: 90px;\n  line-height: 0.6;\n  color: rgba(255, 255, 255, 0.25);\n  margin-bottom: 12px;\n}\n.about-values {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n.about-values li {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 22px 24px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 14px;\n  font-size: 17px;\n  font-weight: 600;\n  transition: background 0.25s ease, transform 0.8s ease, opacity 0.8s ease;\n}\n.about-values li:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n.about-value-num {\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n/* Vision */\n.about-vision {\n  background: #f6f4f1;\n}\n.about-globe {\n  position: relative;\n  width: 150px;\n  height: 150px;\n  margin-top: 44px;\n}\n.about-globe span {\n  position: absolute;\n  inset: 0;\n  border: 2px solid #2e2e2e;\n  border-radius: 50%;\n}\n.about-globe span:nth-child(2) {\n  transform: scaleX(0.45);\n}\n.about-globe span:nth-child(3) {\n  transform: scaleY(0.45);\n}\n\n/* Closing */\n.about-closing {\n  padding: 120px 0;\n  text-align: center;\n}\n.about-closing-title {\n  font-size: clamp(28px, 4.4vw, 52px);\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  line-height: 1.15;\n  max-width: 800px;\n  margin: 0 auto 40px;\n}\n.about-cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  background: #2e2e2e;\n  color: #fff;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 17px;\n  padding: 18px 36px;\n  border-radius: 999px;\n  transition: transform 0.25s ease, box-shadow 0.25s ease, gap 0.25s ease, opacity 0.8s ease;\n}\n.about-cta:hover {\n  gap: 18px;\n  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.2);\n}\n\n/* Tablet / mobile */\n@media (max-width: 900px) {\n  .about-section { padding: 72px 0; }\n  .about-two-col,\n  .about-two-col.reverse { grid-template-columns: 1fr; gap: 32px; }\n  .about-col-head { position: static; }\n  .about-globe { width: 100px; height: 100px; margin-top: 28px; }\n  .about-timeline { grid-template-columns: 1fr 1fr; row-gap: 48px; margin-top: 60px; }\n  .about-timeline::before { display: none; }\n  .about-mission-grid { grid-template-columns: 1fr; gap: 28px; margin-top: 40px; }\n  .about-values { grid-template-columns: 1fr; }\n  .about-quote { margin: 60px auto 48px; }\n}\n\n@media (max-width: 560px) {\n  .about-container { padding: 0 20px; }\n  .about-hero { padding: 80px 0 72px; }\n  .about-scroll-hint { margin-top: 36px; height: 44px; }\n  .about-timeline { grid-template-columns: 1fr; }\n  .about-col-body .about-lead-p { font-size: 18px; }\n  .about-col-body p { font-size: 16px; }\n  .about-closing { padding: 80px 0; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .reveal { opacity: 1; transform: none; transition: none; }\n  .about-hero-glow, .about-scroll-hint { animation: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
